import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrListTermHistoryPathParameters } from 'api/actions/hr-list-term-history/hr-list-term-history-path-parameters';
import { HrListTermHistoryResponse } from 'api/actions/hr-list-term-history/hr-list-term-history-response';

type HrListTermHistoryQueryParameters = Record<string, any>;

/**
 * The path of the HrListTermHistory action.
 */
export const hrListTermHistoryActionPath = new SweetPath<keyof HrListTermHistoryPathParameters>(
  '/api/hr/terms/{termId}/history',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrListTermHistory actions.
 */
export default function createHrListTermHistoryAction(axios: AxiosInstance) {
  return function hrListTermHistoryAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrListTermHistoryPathParameters;
    query?: HrListTermHistoryQueryParameters;
  }) {
    const path = hrListTermHistoryActionPath.insert(parameters);

    return axios.request<HrListTermHistoryResponse, HrListTermHistoryResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
